import * as _dateformat from 'dateformat';

export type DateType = Date | number | string;

export function getDate(date: DateType): Date {
    let d: Date;
    if (typeof (date) == 'number') {
        d = new Date(date * 1000);
    } else if (typeof (date) == 'string') {
        d = new Date(parseInt(date) * 1000);
    } else {
        d = date;
    }
    return d;
}

export function dateformat(dt: DateType, format: string) {
    return _dateformat(getDate(dt), format);
}

// export function getAge(date: DateType) {
//     var birthday = getDate(date);
//     var now = new Date();
//
//     return now.getFullYear() - birthday.getFullYear();
// }
//
// export function getSecond(date: DateType) {
//     var d = getDate(date);
//     var now = Date.now();
//     return (d.getTime() - now) / 1000;
// }

export function getTimeDifference(seconds) {
    return {
        total: seconds,
        days: Math.floor(seconds / (3600 * 24)),
        hours: Math.floor(seconds / 3600),
        minutes: Math.floor(seconds / 60 % 60),
        seconds: Math.floor(seconds % 60),
        milliseconds: Number((seconds % 1 * 1000).toFixed()),
        completed: seconds <= 0,
    };
}

export function formatDate(date, fmtStr?) {
    let fmt = fmtStr ? fmtStr : 'yyyy-MM-dd hh:mm';
    date = new Date(date);
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    // 遍历这个对象
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
}

function padLeftZero(str) {
    return ('00' + str).substr(str.length);
}

export function countdown(second) {
    let timeDifference = getTimeDifference(second);
    return (timeDifference.hours < 10 ? '0' + timeDifference.hours : timeDifference.hours) + ':' +
        (timeDifference.minutes < 10 ? '0' + timeDifference.minutes : timeDifference.minutes) + ':' +
        (timeDifference.seconds < 10 ? '0' + timeDifference.seconds : timeDifference.seconds);
}

// 单纯分钟和秒倒计时
export function resetTime(time) {
    let t = time;
    let m: any = 0;
    let s: any = 0;
    m = Math.floor(t / 60 % 60);
    s = Math.floor(t % 60);

    s--;
    s < 10 && (s = '0' + s);
    if (s.length >= 3) {
        s = 59;
        m = (Number(m) - 1);
    }
    return m + ':' + s;
}

// function GetSpecialDays(y) {
//     if (y % 400 === 0 || (y % 4 === 0 && y % 100 !== 0)) return 29;
//     return 28;
// }
//
// let constellations = [
//     {'Start': 121, 'End': 220, 'Name': '水瓶座'}, {'Start': 221, 'End': 320, 'Name': '双鱼座'},
//     {'Start': 321, 'End': 420, 'Name': '白羊座'}, {'Start': 421, 'End': 520, 'Name': '金牛座'},
//     {'Start': 521, 'End': 620, 'Name': '双子座'}, {'Start': 621, 'End': 720, 'Name': '巨蟹座'},
//     {'Start': 721, 'End': 820, 'Name': '狮子座'}, {'Start': 821, 'End': 920, 'Name': '处女座'},
//     {'Start': 921, 'End': 1020, 'Name': '天秤座'}, {'Start': 1021, 'End': 1120, 'Name': '天蝎座'},
//     {'Start': 1121, 'End': 1220, 'Name': '射手座'}];

// export function getConstellation(dt: DateType) {
//     let date = getDate(dt);
//     let y = date.getFullYear();
//     let m = date.getMonth() + 1;
//     let d = date.getDate();
//     let daysInMonth = [31, 99, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
//     if (y < 1970 || y > 2099) return '';
//     if (m < 1 || m > 12) return '';
//     let mDays = daysInMonth[m - 1];
//     if (m === 2) {
//         mDays = GetSpecialDays(y);
//     }
//     if (d < 0 || d > mDays) return '';
//     let pos = m * 100 + d;
//     for (let i in constellations) {
//         if (pos >= constellations[i].Start && pos <= constellations[i].End) {
//             return constellations[i].Name;
//         }
//     }
// }


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/date.ts